import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { FormBaseComponent } from '../form-base/form-base.component';
import { provideParentFormGroup } from '../forms.utils';

@Component({
  selector: 'app-form-toggle',
  imports: [CommonModule, TranslateModule, MatSlideToggleModule, ReactiveFormsModule, MatInputModule],
  templateUrl: './form-toggle.component.html',
  styleUrls: ['./form-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
})
export class FormToggleComponent extends FormBaseComponent {}
